export default function Toast(pros: any) {
    // Inline CSS styles
    const toastStyle: any = {
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        backgroundColor: pros.bgColor ? pros.bgColor : '#333',
        color: pros.textColor ? pros.textColor : 'white',
        padding: '7px 13px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        zIndex: 9999,
    };

    const closeButtonStyle = {
        background: 'none',
        border: 'none',
        color: pros.crossColor ? pros.crossColor : 'white',
        fontSize: pros.fontSize ? pros.fontSize : '16px',
        fontWeight: pros.fontWeight ? pros.fontWeight : '400',
        lineHeight: '1',
        cursor: 'pointer',
    };

    if (!pros.visible) return null;

    return (
        <div style={toastStyle}>
            <span>{pros.message}</span>
            <button onClick={pros.onClose} style={closeButtonStyle}>
                ×
            </button>
        </div>
    );
}

